// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleSceneItem_BlueBack__LNSYb {
  height: 20px;
}

.ScheduleSceneItem_BreakTitle__xzruw {
  border-top: 10px solid #e8f0f1;
}

.ScheduleSceneItem_BgBox__M34XY {
  border: 1px solid #72dbe2;
  color: #333;
  font-weight: 700;
}

.ScheduleSceneItem_Close__0h9ay {
  /* color: rgb(28, 131, 131); */
  color: rgb(32, 201, 201);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.ScheduleSceneItem_Break__AXpMi {
  border-top: 10px solid #d0d9db;
}

.ScheduleSceneItem_BreakBlack__vHQtR {
  border-top: 5px solid #000;
}

.ScheduleSceneItem_Break4__wsKk- {
  border-top: 1px solid #b1b5b6;
}


.ScheduleSceneItem_Small__gdOqU {
  font-size: .7rem;
  color: #1da3aa;
  font-style: italic;
}

.ScheduleSceneItem_SceneBox__R\\+v\\+0 {
  border: 1px solid #fafafa;
  background-color: #fff;
} 

.ScheduleSceneItem_SceneBox__R\\+v\\+0 p {
  font-size: .8rem !important;
  font-weight: 700;
}

.ScheduleSceneItem_SceneBox__R\\+v\\+0 h5 {
  font-size: 1rem ;
  font-weight: 700;
}

.ScheduleSceneItem_White__cWqCz {
  background-color: #fff;
}

.ScheduleSceneItem_BoldTitle2__2ZTop {
  font-weight: 700;
  border-right : 2px solid #fafafa;
  background-color: #d6fcff;
}

.ScheduleSceneItem_CharactersTitle__p2LiX {
  color: rgb(40, 189, 189);
  color: rgba(89, 70, 14, 0.99);
  font-weight: 600;
}

.ScheduleSceneItem_Item__AkL2g {
    background-color: #1ea7ae;
    color: #fff;
    cursor: pointer;
  }
  
.ScheduleSceneItem_Item__AkL2g:hover {
    background-color: #3b444b;
} 

.ScheduleSceneItem_ItemNu__KKQt\\+ {
  background-color: #43606a;
  color: #fff;
} 

.ScheduleSceneItem_Item__AkL2g:hover .ScheduleSceneItem_ItemNu__KKQt\\+ {
    background-color: #3b444b;
} 

.ScheduleSceneItem_Italic__t-N1V {
  font-style: italic;
  /* font-size: .7rem; */
}

@media screen and (max-width: 600px) {

.ScheduleSceneItem_SceneBox__R\\+v\\+0 h5 {
  font-size: .8rem ;
  font-weight: 700;
}

}`, "",{"version":3,"sources":["webpack://./src/styles/ScheduleSceneItem.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;AAEF;IACI,yBAAyB;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA","sourcesContent":[".BlueBack {\n  height: 20px;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.BgBox {\n  border: 1px solid #72dbe2;\n  color: #333;\n  font-weight: 700;\n}\n\n.Close {\n  /* color: rgb(28, 131, 131); */\n  color: rgb(32, 201, 201);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.BreakBlack {\n  border-top: 5px solid #000;\n}\n\n.Break4 {\n  border-top: 1px solid #b1b5b6;\n}\n\n\n.Small {\n  font-size: .7rem;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.SceneBox {\n  border: 1px solid #fafafa;\n  background-color: #fff;\n} \n\n.SceneBox p {\n  font-size: .8rem !important;\n  font-weight: 700;\n}\n\n.SceneBox h5 {\n  font-size: 1rem ;\n  font-weight: 700;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.BoldTitle2 {\n  font-weight: 700;\n  border-right : 2px solid #fafafa;\n  background-color: #d6fcff;\n}\n\n.CharactersTitle {\n  color: rgb(40, 189, 189);\n  color: rgba(89, 70, 14, 0.99);\n  font-weight: 600;\n}\n\n.Item {\n    background-color: #1ea7ae;\n    color: #fff;\n    cursor: pointer;\n  }\n  \n.Item:hover {\n    background-color: #3b444b;\n} \n\n.ItemNu {\n  background-color: #43606a;\n  color: #fff;\n} \n\n.Item:hover .ItemNu {\n    background-color: #3b444b;\n} \n\n.Italic {\n  font-style: italic;\n  /* font-size: .7rem; */\n}\n\n@media screen and (max-width: 600px) {\n\n.SceneBox h5 {\n  font-size: .8rem ;\n  font-weight: 700;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BlueBack": `ScheduleSceneItem_BlueBack__LNSYb`,
	"BreakTitle": `ScheduleSceneItem_BreakTitle__xzruw`,
	"BgBox": `ScheduleSceneItem_BgBox__M34XY`,
	"Close": `ScheduleSceneItem_Close__0h9ay`,
	"Break": `ScheduleSceneItem_Break__AXpMi`,
	"BreakBlack": `ScheduleSceneItem_BreakBlack__vHQtR`,
	"Break4": `ScheduleSceneItem_Break4__wsKk-`,
	"Small": `ScheduleSceneItem_Small__gdOqU`,
	"SceneBox": `ScheduleSceneItem_SceneBox__R+v+0`,
	"White": `ScheduleSceneItem_White__cWqCz`,
	"BoldTitle2": `ScheduleSceneItem_BoldTitle2__2ZTop`,
	"CharactersTitle": `ScheduleSceneItem_CharactersTitle__p2LiX`,
	"Item": `ScheduleSceneItem_Item__AkL2g`,
	"ItemNu": `ScheduleSceneItem_ItemNu__KKQt+`,
	"Italic": `ScheduleSceneItem_Italic__t-N1V`
};
export default ___CSS_LOADER_EXPORT___;
